import { useEffect } from 'react'
import { useRouter } from 'expo-router'
import { Spinner, Text, YStack } from 'tamagui'

import { useApp } from '../../../src/i18n'

/**
 * Технический экран: сюда Keycloak возвращает человека с кодом авторизации. Код подхватывает
 * `expo-auth-session` в том окне, где начинался вход, поэтому здесь делать нечего — ждём и
 * уходим в кабинет. Маршрут обязан существовать: адрес `/cabinet/auth/callback` прописан в
 * redirect_uri клиента, и без своего экрана роутер отдал бы 404.
 */
export default function CabinetAuthCallback() {
  const router = useRouter()
  const { l } = useApp()

  useEffect(() => {
    const timer = setTimeout(() => router.replace('/cabinet'), 300)
    return () => clearTimeout(timer)
  }, [router])

  return (
    <YStack flex={1} alignItems="center" justifyContent="center" gap={12} backgroundColor="$bgLayout">
      <Spinner size="large" color="$primary" />
      <Text color="$textMuted">{l('cab.title')}</Text>
    </YStack>
  )
}
